import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getAccount, fetchAccount } from 'src/account';
import { getToken } from 'src/auth';
import { toast } from 'react-toastify';
import { getUser } from 'src/user';
;
import { Button, Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;;
import { UiTable } from 'src/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import propTypes from 'prop-types';
import { fetchLoggedInUser } from '../../user';
import { reduceServerErrors, UiToastAdapter, InnerLoader } from '../../ui';
import { updateAccountAgents } from '../redux/account';

/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */

const AssignAgentPage = ({
  account,
  token,
  user,
  updateAccountAgents,
  fetchAccount,
  fetchLoggedInUser,
}) => {
  const [primaryAgents, setPrimaryAgents] = useState([]);
  const [secondaryAgents, setSecondaryAgents] = useState([]);
  const [people, setPeople] = useState([]);
  const [isChanged, setIsChanged] = useState(false);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const { id } = useParams();
  const [initAgents, setInitAgents] = useState(null);
  const [isPrimaryAdmin, setIsPrimaryAdmin] = useState(false);
  useEffect(() => {
    if (account.primaryAgents || account.secondaryAgents) {
      setInitAgents({
        primary: account.primaryAgents,
        secondary: account.secondaryAgents,
      });
    }
  }, [account]);
  useEffect(() => {
    (async () => {
      setLoading(true);
      if (token.isValid()) {
        if (!user.isValid()) {
          await fetchLoggedInUser();
        } else {
          setIsPrimaryAdmin(
            user.isPrimaryBankAdmin || user.isPrimaryMerchantAdmin
          );
        }

        if (id) {
          await fetchAccount(id);
          setPeople(account.people);
          setPrimaryAgents(account.primaryAgents);
          setSecondaryAgents(account.secondaryAgents);
          setLoading(false);
          if (account.isError()) {
            reduceServerErrors(account);
          }
        }
      }
    })();
  }, [refresh]);

  const addAgent = (id, type) => {
    const temp = [...people];
    const person = temp.find(p => p.id === id);
    person.agentRole = type !== '' ? type : null;
    if (type === 'Primary Agent') {
      setPrimaryAgents(primaryAgents => [...primaryAgents, id]);
      const tempSecondary = secondaryAgents.filter(i => i !== id);
      setSecondaryAgents(tempSecondary);
    }
    if (type === 'Secondary Agent') {
      setSecondaryAgents(secondaryAgents => [...secondaryAgents, id]);
      const tempPrimary = primaryAgents.filter(i => i !== id);
      setPrimaryAgents(tempPrimary);
    }
    if (!type) {
      const tempPrimary = primaryAgents.filter(i => i !== id);
      const tempSecondary = secondaryAgents.filter(i => i !== id);
      setPrimaryAgents(tempPrimary);
      setSecondaryAgents(tempSecondary);
    }
    setPeople(people => temp);
    setIsChanged(true);
  };

  const processAgentChange = (primaryAgents, secondaryAgents) => {
    const addPrimary = primaryAgents.filter(
      x => !initAgents.primary.includes(x)
    );
    const deletePrimary = initAgents.primary.filter(
      x => !primaryAgents.includes(x)
    );
    const addSecondary = secondaryAgents.filter(
      x => !initAgents.secondary.includes(x)
    );
    const deleteSecondary = initAgents.secondary.filter(
      x => !secondaryAgents.includes(x)
    );

    return {
      addPrimary,
      deletePrimary,
      addSecondary,
      deleteSecondary,
    };
  };
  const onSubmit = async () => {
    const {
      addPrimary,
      deletePrimary,
      addSecondary,
      deleteSecondary,
    } = processAgentChange(primaryAgents, secondaryAgents);
    await updateAccountAgents({
      addPrimary,
      addSecondary,
      deletePrimary,
      deleteSecondary,
      accountId: account.id,
      financialInstitutionId: user.financialInstitutionId,
    });
    toast(UiToastAdapter('Agents Updated Successfully', 'success'));
    setIsChanged(false);
    setInitAgents(null);
    setRefresh(!refresh);
  };
  return (
    <>
      <Columns isMultiline>
        <Column isSize="1/2">
          <MuiTitle isSize="4" hasTextColor="info" tag="h2">
            Assigned Agents: {account.businessName}
          </MuiTitle>
        </Column>
        <Column hasTextAlign="right">
          <div>
            {isPrimaryAdmin && (
              <>
                <Button
                  disabled={!isChanged}
                  className="is-gradient-bright"
                  onClick={onSubmit}
                >
                  Submit
                </Button>
              </>
            )}
          </div>
        </Column>
      </Columns>
      {!account.isLoading() && !loading && (
        <AgentTable
          addAgent={addAgent}
          people={people}
          account={account}
          setPeople={setPeople}
          setPrimaryAgents={setPrimaryAgents}
          setSecondaryAgents={setSecondaryAgents}
          isPrimaryAdmin={isPrimaryAdmin}
        />
      )}
      {loading && <InnerLoader visible />}
    </>
  );
};

function mapStateToProps(state) {
  return {
    token: getToken(state),
    user: getUser(state),
    account: getAccount(state),
  };
}

const connectedAssignAgentsPage = connect(mapStateToProps, {
  fetchAccount,
  fetchLoggedInUser,
  updateAccountAgents,
})(AssignAgentPage);

const AgentTable = ({
  people,
  addAgent,
  account,
  setPeople,
  setPrimaryAgents,
  setSecondaryAgents,
  isPrimaryAdmin,
}) => {
  useEffect(() => {
    const peopleConcat = [...account.fiAdmins];
    if (account.initiatedBy) {
      peopleConcat.push(account.initiatedBy);
    }
    setPeople(peopleConcat);
    setPrimaryAgents(account.primaryAgents);
    setSecondaryAgents(account.secondaryAgents);
  }, []);

  /* eslint-disable*/

  const tableColumns = [
    {
      Header: () => (
        <span className="icon is-small table-header-member-icon">
          <FontAwesomeIcon icon={['fas', 'user-circle']} size="2x" />
        </span>
      ),
      Cell: ({ original }) => (
        <div className={`person-status ${original.statusClassName}`}>
          <span>
            <FontAwesomeIcon icon={['fas', 'user-circle']} size="2x" />
            {original.isAdmin && (
              <span className="icon-tag hidden-hover">
                <FontAwesomeIcon icon={['fas', 'star']} />
              </span>
            )}
          </span>
        </div>
      ),
      sortable: false,
      width: 65,
      resizable: false,
      filterable: false,
    },
    {
      Header: 'Person',
      accessor: 'name',
      filterMethod: (_filter, row) => {
        return [row._original.name].some(v =>
          v.toLowerCase().includes(_filter.value.toLowerCase())
        );
      },
      Cell: ({ original, value }) => (
        <div className="member-name">
          <div>
            <span>{value}</span>
          </div>
          <small className="has-text-grey-medium-dark">
            {original.title && `${original.title} | `}
            {original.emailAddress}
          </small>
        </div>
      ),
      width: 1000,
    },
    {
      Header: 'Agent Role',
      accessor: 'agentRole',
      Cell: ({ original }) => (
        <div style={{ marginTop: '5px' }}>
          {isPrimaryAdmin && (
            <>
              <div className="select" style={{ display: 'flex' }}>
                <select
                  defaultValue={original.agentRole ? original.agentRole : ''}
                  onChange={e =>
                    addAgent(original.id, e.target.value, original.agentRole)
                  }
                >
                  <option value=""> No Role</option>
                  <option value="Primary Agent">Primary</option>
                  <option value="Secondary Agent">Secondary</option>
                </select>
              </div>
            </>
          )}
          {!isPrimaryAdmin && (
            <>
              <div className="member-name">
                <span>
                  {original.agentRole ? original.agentRole : 'No Role'}
                </span>
              </div>
            </>
          )}
        </div>
      ),
      width: 150,
      filterable: false,
    },
  ];

  /* eslint-enable */

  return (
    <>
      <UiTable
        className="people-table -highlight"
        isAlign="right"
        columns={tableColumns}
        data={people}
        useTablePagination
        title="Agents"
        resolveData={data =>
          data.map(transaction => ({
            ...transaction,
          }))
        }
        hidePrev
        hideNext
        hideButton
        filterable
      />
    </>
  );
};
export { connectedAssignAgentsPage as AssignAgentPage };

AssignAgentPage.propTypes = {
  account: propTypes.object.isRequired,
  token: propTypes.object.isRequired,
  user: propTypes.object.isRequired,
  updateAccountAgents: propTypes.func.isRequired,
  fetchAccount: propTypes.func.isRequired,
  fetchLoggedInUser: propTypes.func.isRequired,
};

AgentTable.defaultProps = {
  people: [],
};
AgentTable.propTypes = {
  people: propTypes.array,
  addAgent: propTypes.func.isRequired,
  account: propTypes.object.isRequired,
  setPeople: propTypes.func.isRequired,
  setPrimaryAgents: propTypes.func.isRequired,
  setSecondaryAgents: propTypes.func.isRequired,
  isPrimaryAdmin: propTypes.bool.isRequired,
};
